import { withError, withIcon, withMask } from "../enhancers";
import Input from "../views/Input";
export default withError(withIcon(withMask(Input)));